export const profilePageConstraint = (translateKey1: string): {[key: string]: any} => {
  return {
    firstName: {
      presence: {
        allowEmpty: false,
        message: translateKey1
      },
    },

    lastName: {
      presence: {
        allowEmpty: false,
        message: translateKey1
      },
    },

  };

};